import {Dragging} from './Skills.module.css';
import {SkillBoxDragging} from './Skill/Skill.module.css';


const skillsDragProperties={
    isMouseDown:false,
    mouseInitialX:undefined,
    initialScrollLeft:undefined
}


export function skillsHeaderClickHandler({skillsContainerRef:{current:skillsContainerDOM}}){
    skillsContainerDOM.scrollTo({left:0,behavior:'smooth'})
}
export function skillsContainerMouseDownHandler
    ({skillsContainerRef:{current:skillsContainerDOM}},mouseDownEvent){
        skillsDragProperties['isMouseDown']=true;
        skillsDragProperties['mouseInitialX']=mouseDownEvent.pageX-skillsContainerDOM.offsetLeft;
        skillsDragProperties['initialScrollLeft']=skillsContainerDOM.scrollLeft;
}
export function skillsContainerMouseLeaveHandler(){
    skillsDragProperties['isMouseDown']=false;
}
export function skillsContainerMouseMoveHandler(
    {skillsSectionRef:{current:skillsSectionDOM},
    skillsContainerRef:{current:skillsContainerDOM},
    skillBoxesRef:{current:skillBoxesDOM}},
    mouseMoveEvent){
        const {isMouseDown,mouseInitialX,initialScrollLeft}=skillsDragProperties;
        if (!isMouseDown)    
            return;
        mouseMoveEvent.preventDefault();
        const mouseCurrentX=mouseMoveEvent.pageX-skillsContainerDOM.offsetLeft;
        const scrollDeviation=mouseCurrentX-mouseInitialX;
        skillsContainerDOM.scrollLeft=initialScrollLeft-scrollDeviation;
        skillsSectionDOM.classList.add(Dragging);
        skillBoxesDOM.forEach((skillBox)=>{
            skillBox.classList.add(SkillBoxDragging)
        })
}
export function skillsContainerMouseUpHandler(
    {skillsSectionRef:{current:skillsSectionDOM},
    skillBoxesRef:{current:skillBoxesDOM}}){
    skillsDragProperties['isMouseDown']=false;
    skillsSectionDOM.classList.remove(Dragging);
    skillBoxesDOM.forEach((skillBoxDOM)=>{
        skillBoxDOM.classList.remove(SkillBoxDragging)
    })
}